<section ngClass.gt-sm="large" fxLayout="column" fxLayoutGap="16px">
  <div class="dialog-title">
    <mat-icon>warning</mat-icon>
    <h2>{{ data.title }}</h2>
  </div>
  <div class="mat-body dialog-message" mat-dialog-content>
    <span [innerHTML]="data.message"></span>

    @if (data.warningMessage) {
      <span class="warning">
        {{ ' ' + data.warningMessage }}
      </span>
    }
  </div>
  @if (data.infoBubleWarningMessage || data.infoBubleWarningTitle) {
    <app-info-bubble
      [type]="InfoBubbleType.Warning"
      [title]="data.infoBubleWarningTitle"
      [message]="data.infoBubleWarningMessage"
    >
    </app-info-bubble>
  }
  @if (data.checkboxLabel) {
    <mat-checkbox
      [checked]="data.checkboxChecked || false"
      (change)="data.checkboxChecked = $event.checked"
    >
      {{ data.checkboxLabel | translate }}
    </mat-checkbox>
  }
  <mat-toolbar
    fxLayout="row"
    fxLayoutAlign="flex-end flex-end"
    fxLayoutGap="20px"
    fxLayout.lt-sm="column"
    fxLayoutGap.lt-sm="12px"
    ngClass.lt-sm="mobile"
  >
    @if (!data.hideCancel) {
      <button mat-stroked-button color="darkblue" [mat-dialog-close]="false">
        {{
          data.cancel
            ? (data.cancel | translate)
            : ('common.cancel' | translate)
        }}
      </button>
    }
    <button
      class="no-border filled"
      color="yellow"
      mat-stroked-button
      [mat-dialog-close]="true"
    >
      {{
        data.confirm
          ? (data.confirm | translate)
          : ('common.proceed' | translate)
      }}
    </button>
  </mat-toolbar>
</section>
